module.exports = __webpack_public_path__ + "img/30a9d519db77957b11e61e823614cd4a.8c0b4795.png";